import { CalculatorSetter } from '@4finance/cwt-test-helper';
import { PERSONAL_DETAILS } from 'Router/routes';

export const calculatorSetters: CalculatorSetter[] = [
  {
    url: PERSONAL_DETAILS,
    value: 5000,
    name: 'Setup for Upsale',
  },
  {
    url: PERSONAL_DETAILS,
    value: 30000,
    name: 'Setup for Downsale',
  },
];
